import { createActionTypeModel } from "../../../../store/global/action-model";

export const ContactFiles = createActionTypeModel('ContactFiles');
export const ContactFilesSearchResult = createActionTypeModel('ContactFilesSearchResult');
export const SET_CONTACT_FILES_LIST_START_ROW = "SET_CONTACT_FILES_LIST_START_ROW";